export default "__VITE_ASSET__e288eb83__"